import { CommonModule } from "@angular/common";
import { booleanAttribute, Component, input } from "@angular/core";
import { HlmSpinner } from "@o2-fe/ui";

@Component({
  selector: "app-loader",
  imports: [CommonModule, HlmSpinner],
  templateUrl: "./loader.component.html",
})
export class LoaderComponent {
  readonly isLoading = input(false, { transform: booleanAttribute });
}
